<template>
    <f7-page>
        <f7-navbar title="编辑设备" back-link="返回">
        </f7-navbar>
        <f7-list inline-labels no-hairlines-md>
            <f7-list-input label="设备名"
                           type="text"
                           placeholder="请输入设备名称"
                           validate
                           validate-on-blur
                           error-message="设备名称必填"
                           required
                           :value="deviceName"
                           @input="deviceName = $event.target.value"
                           clear-button></f7-list-input>
        </f7-list>
        <f7-block>
            <div class='btn-ok' @click="updateDevice">确定</div>
        </f7-block>
    </f7-page>
</template>

<script>
  import { f7NavRight, f7Link, f7Navbar, f7List, f7ListItem, f7Badge, f7ListInput, f7Button } from 'framework7-vue'
  import BaseToolbar from 'components/baseToolbar/BaseToolbar'
  import { globalConst as native, modalTitle } from 'lib/const'
  import { mapState } from 'vuex'

  export default {
    props: {
      index: [Number, String]
    },
    name: '',
    data () {
      return {
        deviceName: '?',
        deviceMacAddr: ''
      }
    },
    created () {
      console.log('index==>', this.index)
      const device = this.deviceList[this.index]
      this.deviceName = device.name || ''
      this.deviceMacAddr = device.macAddr
    },
    methods: {
      updateDevice () {
        let error = document.querySelector('.item-input-invalid .item-input-error-message')
        const {deviceMacAddr, deviceName} = this
        if (!deviceName) {
          this.$f7.dialog.alert('设备名称必填', modalTitle)
          return
        }
        if (error) {
          this.$f7.dialog.alert(error.innerText, modalTitle)
          return
        }
        this.$store.dispatch({
          type: native.updateDevice,
          macAddr: deviceMacAddr,
          name: deviceName
        }).then(() => {
          this.$store.commit('setDeviceName', {index: this.index, deviceName})
          this.$f7.dialog.alert('更新成功', () => {
            this.$f7router.back()
          })
        })
      }
    },
    computed: {
      ...mapState({
        deviceList: ({device}) => device.deviceList
      })
    },
    components: {f7Navbar, f7NavRight, f7Link, BaseToolbar, f7List, f7ListItem, f7Badge, f7ListInput, f7Button}
  }
</script>

<style lang="scss" scoped type="text/css">

</style>